<template>
  <Card>
    <template #title>Latest API Error</template>
    <template #content>
      <ScrollPanel class="h-[60vh] w-full shadow-xl border-1 border-surface-200 dark:border-surface-600 rounded-2xl">
        <p class="dark:text-surface-300 whitespace-break-spaces p-5">{{ props.recentErrorLog }}</p>
      </ScrollPanel>
    </template>
  </Card>

  <div class="w-full flex-row flex mt-3">
    <Button @click="downloadApiLog" class="mx-auto">Download Full API Error Log</Button>
  </div>
</template>

<script setup lang="ts">
import { fileSaveAs } from "@/services/Utility";

interface Props {
  recentErrorLog: String;
}
const props = defineProps<Props>();

const downloadApiLog = (): void => {
  fileSaveAs("/errorlog/download", "accudraw-api.log");
};
</script>
